/* ════ DATE ════════════════════════════════════════════════ */
export const pdate = s => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
export const fdate = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const ddiff = (a, b) => Math.round((b - a) / 86400000);
export const addD = (d, n) => { const r = new Date(d); r.setDate(r.getDate() + n); return r; };
export const isoWk = d => { const j = new Date(d.getFullYear(), 0, 1); return Math.ceil(((d - j) / 86400000 + j.getDay() + 1) / 7); };
export const isWE = d => d.getDay() === 0 || d.getDay() === 6;
export const isMon = d => d.getDay() === 1;

// Inclusive end date covering `n` working days from `start` (start moved to the
// next weekday if it lands on a weekend). e.g. 3 working days from a Friday → Tue.
export function workingEnd(start, n) {
  const d = new Date(start);
  while (isWE(d)) d.setDate(d.getDate() + 1);
  let count = 1;
  while (count < n) { d.setDate(d.getDate() + 1); if (!isWE(d)) count++; }
  return d;
}
